<section>
  <div class="form-register">
    <form [formGroup]="formSubrentalOutputDetail">
      <div class="row p-1">
        <div class="col-lg-2 col-md-4 col-sm-6 col-6">
          <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStores" [required]="true"
            [recovery]="true" (onChangeSelect)="getStore($event, true)"></app-custom-select>
        </div>

        <div class="col-lg-2 col-md-4 col-sm-6 col-6">
          <app-custom-inputgroup [inputValue]="codeNameArticle" [labelText]="'Artículo'"
            [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Artículo'" [required]="true"
            [recovery]="true" (onClick)="openArticleSelectionModal()"></app-custom-inputgroup>
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Equipos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        </div>

        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="stock" [labelText]="'Existencias'"></app-custom-input-decimal>
        </div>

        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantity" [labelText]="'Cantidad'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-6 col-12 d-flex mt-2">
          <div class="d-flex align-items-end justify-content-end  gap-2 container-buttons bottom-0">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>

      </div>
    </form>
  </div>
</section>